function Error() {
    return (
        <div className="error">
            <h1>An error occurred while loading the page.</h1>
            <p>If after several tries this error still occurs, please contact me by email at this address: <a href="mailto:alkanife@gmail.com">alkanife@gmail.com</a>.</p>
        </div>
    )
}

export default Error;